import { EntityWithDocumentFullResponse } from '@/modules/entity/types/EntityItemResponse.ts';
import {
  RenderIndividualPersonsDetails,
  renderEntityContactDetails,
  renderEntityDetailsSection,
  renderEntityDocuments,
  renderEntityTaxResidence,
} from '@/modules/entity/utils/entity-info/entity-info.tsx';

export const RenderPartnershipEntityDetails = ({
  partnership_entity_details,
  document_files,
  ...entity_details
}: Partial<EntityWithDocumentFullResponse>) => {
  const {
    country,
    abn,
    entity_number,
    partnership_type,
    registered_office,
    principal_place_of_business,
    stakeholders,
    is_us_person,
    non_us_person_certification,
    tax_residence,
    account_holders_gin,
    sponsoring_entity_name,
    is_managed_by_another_institution,
    crs_status,
    company_name,
  } = partnership_entity_details || {};

  const { bank_name, bank_account_bsb, bank_account_number, bank_account_name } =
    entity_details || {};

  return (
    <>
      {renderEntityContactDetails(entity_details)}
      {renderEntityDetailsSection({
        name: 'Partnership details',
        items: [
          { label: 'Name', value: company_name },
          { label: 'Country', value: country },
          { label: 'ABN', value: abn },
          { label: 'Entity number', value: entity_number },
          { label: 'Partnership type', value: partnership_type },
          { label: 'Registered office', value: registered_office },
          { label: 'Principal place of business', value: principal_place_of_business },
        ],
      })}
      {RenderIndividualPersonsDetails({ persons: stakeholders, role: 'Stakeholder' })}
      {renderEntityTaxResidence(tax_residence)}
      {renderEntityDetailsSection({
        items: [
          { label: 'GIIN', value: account_holders_gin },
          { label: 'Sponsoring entity name', value: sponsoring_entity_name },
          {
            label:
              'Is the Account Holder a specified U.S. person? A U.S. person includes a U.S. citizen or resident alien of the U.S. even if residing outside the U.S.',
            value: is_us_person,
          },
          { label: 'Non U.S Person Certification', value: non_us_person_certification },

          {
            label: 'Is the entity an Investment Entity managed by another Financial Institution?',
            value: is_managed_by_another_institution,
          },
          { label: 'CRS status', value: crs_status },
        ],
      })}
      {renderEntityDetailsSection({
        name: 'Payment instructions',
        items: [
          { label: 'Bank name', value: bank_name },
          { label: 'BSB', value: bank_account_bsb },
          { label: 'Account number', value: bank_account_number },
          { label: 'Account name', value: bank_account_name },
        ],
      })}
      {renderEntityDocuments(document_files || [])}
    </>
  );
};
